import { combineReducers } from "redux";
import userReducer from "../user/reducer";
import gameReducer from "../games/reducer";
import errorReducer from "../errorReducer/reducer";
import adminUserReducer from "../AdminUser/reducer";
import avatarReducer from "../Avatar/reducer";
import settingReducer from "../settings/reducer";
import { SDKManagementReducer } from "../SDKManagement/reducer";
import { authReducer } from "../auth/reducer";
import analyticsReducer from "../AnalyticsReport/reducer";
import footerReducer from "Redux/Design/reducer";
import paymentReducer from "Redux/Master/reducer";
import quickChatReducer from "../QuickChat/reducer";
import storePackReducer from "../storePack/reducer";
import diamondPackReducer from "../diamondPack/reducer";
import removeAdsReducer from "../removeAds/reducer";
import gamePlayRoomReducer from "../gamePlayRoom/reducer";
import userRoomsReducer from "../userRooms/reducer";

export default combineReducers({
    authReducer,
    userReducer,
    gameReducer,
    errorReducer,
    adminUserReducer,
    avatarReducer,
    settingReducer,
    SDKManagementReducer,
    analyticsReducer,
    footerReducer,
    paymentReducer,
    quickChatReducer,
    storePackReducer,
    diamondPackReducer,
    removeAdsReducer,
    gamePlayRoomReducer,
    userRoomsReducer,
})